export const bankAccountNoPipe = (
  value: string | undefined,
  bankCd?: string
): string => {
  if (!value) return "-";

  const split = value.split("/");

  const accNo = split[0].toString();

  switch (bankCd) {
    /**
     * 은행코드
     * 002: 산업은행, 003: 기업은행, 004: 국민은행, 007: 수협은행, 011: 농협은행, 020: 우리은행,
     * 023: SC은행, 027: 씨티은행, 031: 대구은행, 032: 부산은행, 034: 광주은행, 035: 제주은행,
     * 037: 전북은행, 039: 경남은행, 045: 새마을금고중앙회, 048: 신협, 079: 우체국, 081: 하나은행,
     * 088: 신한은행, 089: 케이뱅크, 090: 카카오뱅크
     */
    case "002": // KDB 산업은행
      return accNo.replace(/(\d{3})(\d{4})(\d{4})(\d{3})/, "$1-$2-$3-$4");
    case "003": // IBK 기업은행
      return accNo.replace(/(\d{3})(\d{6})(\d{2})(\d{3})/, "$1-$2-$3-$4");
    case "004": // KB 국민은행
      if (accNo.length == 12) {
        // (구) 12자리인 경우
        return accNo.replace(/(\d{3})(\d{2})(\d{4})(\d{3})/, "$1-$2-$3-$4");
      } else {
        // (신) 14자리인 경우
        return accNo.replace(/(\d{6})(\d{2})(\d{6})/, "$1-$2-$3");
      }
    case "007": // SH 수협
      if (accNo.length == 11) {
        return accNo.replace(/(\d{3})(\d{2})(\d{6})/, "$1-$2-$3");
      } else {
        // 12
        return accNo.replace(/(\d{4})(\d{4})(\d{4})/, "$1-$2-$3");
      }
    case "011": // NH 농협
      if (accNo.length == 12) {
        return accNo.replace(/(\d{4})(\d{2})(\d{6})/, "$1-$2-$3");
      } else {
        // 13
        return accNo.replace(/(\d{3})(\d{4})(\d{4})(\d{2})/, "$1-$2-$3-$4");
      }
    case "020": // WOORI 우리
      return accNo.replace(/(\d{4})(\d{3})(\d{6})/, "$1-$2-$3");
    case "023": // SC 제일은행
      return accNo.replace(/(\d{3})(\d{2})(\d{6})/, "$1-$2-$3");
    case "027": // CITI 씨티은행
      return accNo.replace(/(\d{3})(\d{6})(\d{3})/, "$1-$2-$3");
    case "031": // DGB 대구은행
      return accNo.replace(/(\d{3})(\d{2})(\d{6})(\d{1})/, "$1-$2-$3-$4");
    case "032": // BNK 부산은행
      return accNo.replace(/(\d{3})(\d{4})(\d{4})(\d{2})/, "$1-$2-$3-$4");
    case "034": // KJ 광주은행
      return accNo.replace(/(\d{4})(\d{3})(\d{6})/, "$1-$2-$3");
    case "035": // JEJU 제주은행
      return accNo.replace(/(\d{2})(\d{2})(\d{6})/, "$1-$2-$3");
    case "037": // JB 전북은행
      return accNo.replace(/(\d{3})(\d{2})(\d{7})/, "$1-$2-$3");
    case "039": // KN 경남은행
      return accNo.replace(/(\d{3})(\d{4})(\d{4})(\d{2})/, "$1-$2-$3-$4");
    case "045": // KFCC 새마을금고중앙회
      return accNo.replace(/(\d{4})(\d{4})(\d{4})(\d{1})/, "$1-$2-$3-$4");
    case "048": // CU 신협
      return accNo.replace(/(\d{3})(\d{3})(\d{6})/, "$1-$2-$3");
    case "079": // POST 우체국
      return accNo.replace(/(\d{6})(\d{2})(\d{6})/, "$1-$2-$3");
    case "081": // HANA 하나은행
      if (accNo.length == 12) {
        // (구) 외환은행
        return accNo.replace(/(\d{3})(\d{6})(\d{3})/, "$1-$2-$3");
      } else {
        // 14
        return accNo.replace(/(\d{3})(\d{6})(\d{5})/, "$1-$2-$3");
      }
    case "088": // SHINHAN 신한은행
      if (accNo.length == 11) {
        // (구)
        return accNo.replace(/(\d{3})(\d{2})(\d{6})/, "$1-$2-$3");
      } else {
        // 12
        return accNo.replace(/(\d{3})(\d{3})(\d{6})/, "$1-$2-$3");
      }
    case "089": // KBANK 케이뱅크
      return accNo.replace(/(\d{3})(\d{3})(\d{6})/, "$1-$2-$3");
    case "090": // KAKAO 카카오뱅크
      return accNo.replace(/(\d{4})(\d{2})(\d{7})/, "$1-$2-$3");
    default:
      return accNo;
  }
};

export const bankAccountNoSplitPipe = (value: string | undefined) => {
  if (!value) return "-";
  const split = value.split("/");
  const accNo = split[0].toString();
  return accNo.slice(accNo.length - 4, accNo.length);
};
